import React, { useEffect, useState } from 'react';
import axios from 'axios';
import Header from '../components/Header';
import Footer from '../components/Footer';
import { IoIosSearch, IoLogoWhatsapp } from 'react-icons/io';
import { Link } from 'react-router-dom';
import { Toaster, toast } from 'react-hot-toast';
import { FaEye } from "react-icons/fa";
import { Modal } from 'flowbite-react';
import PharmacyBg from '../assest/images/PharmacyBg.png';
import Image from '../assest/images/37a39cb7092d94d7297953ad09f2dee5.png';

const Pharmacy = () => {
  const [products, setProducts] = useState([]);
  const [filteredProducts, setFilteredProducts] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');
  const [viewModal, setViewModal] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);

  useEffect(() => {
    const fetchProducts = async () => {
      try {
        const response = await axios.get('https://backend.amarasinghemedicare.com/pharmacy/pharmacy');
        setProducts(response.data);
        setFilteredProducts(response.data);
      } catch (error) {
        console.error('Error fetching products:', error);
      }
    };
    fetchProducts();
  }, []);

  const handleSearch = (e) => {
    const value = e.target.value.toLowerCase().trim();
    setSearchTerm(value);

    if (value === "") {
      setFilteredProducts(products);
      return;
    }

    const filtered = products.filter((product) => {
      const name = product.itemName?.toLowerCase() || "";
      const description = product.description?.toLowerCase() || "";
      const category = product.pharmacy?.category?.toLowerCase() || "";

      return (
        name.includes(value) ||
        description.includes(value) ||
        category.includes(value)
      );
    });

    setFilteredProducts(filtered);
  };

  return (
    <div className="flex flex-col min-h-screen">
      <Toaster />
      <Header />
      <main
        className="flex-grow bg-cover bg-center"
        style={{ backgroundImage: `url(${PharmacyBg})`, backgroundPosition: 'center', backgroundSize: 'cover' }}
      >
        <div className=" mx-auto px-4 py-8">
          <div className="flex flex-col sm:flex-row items-center justify-end mb-8">
            <div className="relative flex items-center w-full sm:w-[498px] h-[44px] border border-gray-400 shadow-md rounded-full bg-white ml-auto">
              <input
                type="text"
                placeholder="Search item..."
                value={searchTerm}
                onChange={handleSearch}
                className="p-3 w-full h-full text-gray-400 bg-transparent focus:outline-none placeholder-gray-400"
              />
              <button className="absolute right-2 bg-[#B3B3B3] rounded-full p-2 w-10 sm:w-14 h-8 flex items-center justify-center">
                <IoIosSearch className="w-5 h-5 sm:w-6 sm:h-6 text-white stroke-[15]" />
              </button>
            </div>
          </div>

          <div className="flex flex-wrap">
            {filteredProducts.length > 0 ? (
              filteredProducts.map((item) => (
                <div className="mb-10 px-5 mt-5 w-full sm:w-1/2 md:w-1/3">
                  <div className="h-full p-5 bg-white flex flex-col items-center justify-between rounded-lg shadow-md gap-4">
                    <div className='w-full flex justify-center items-center'>
                      <img
                        className="w-32 h-32 sm:w-42 sm:h-42 md:w-full md:h-64 object-cover"
                        src={`https://backend.amarasinghemedicare.com/Upload/Pharmacy/${item.image}`}
                        alt={item.itemName}
                      />
                    </div>

                    <div className="flex flex-col items-start justify-start w-full flex-grow">
                      <h3 className='text-sm font-extralight'>{item.category || 'Unknown'}</h3>
                      <h1 className="text-base font-semibold text-fontDark">{item.itemName}</h1>
                      <p className="text-sm">
                        {item.description.length > 100
                          ? item.description.slice(0, 50) + "..."
                          : item.description}
                      </p>
                      <h1 className="text-base font-semibold text-fontDark mt-2 flex gap-2 items-center justify-center">
                        {
                          item.discount === 0 ? (
                            <span>රු{Number(item.price).toFixed(2)}</span>
                          ) : (
                            <div className="">
                              <span className="line-through mr-2 text-gray-400">රු{Number(item.price).toFixed(2)}</span>
                              <span className="font-bold text-red">රු{Number(item.price - (item.price * (item.discount / 100))).toFixed(2)}</span>
                            </div>
                          )
                        }
                      </h1>
                      <h3
                        className="text-sm mt-3 cursor-pointer text-blue-500 hover:underline flex gap-1 items-center justify-center"
                        onClick={() => {
                          toast.success('Copied to clipboard');
                        }}
                      >
                        <IoLogoWhatsapp className='text-[#25D366] text-3xl' /> Ask for More Info
                      </h3>
                    </div>

                    <div className='flex w-full justify-center items-center gap-2'>
                      <button type='button' onClick={() => { setSelectedItem(item); setViewModal(true); }} className="mt-auto flex gap-2 items-center justify-center text-md text-white uppercase font-light bg-[#97CE4F] py-2 w-full rounded-lg transform transition-transform duration-300 hover:scale-105">
                        <FaEye className='text-md' /> View Item
                      </button>
                    </div>


                  </div>
                </div>

              ))
            ) : (
              <div>
                No item found
              </div>
            )}
          </div>
        </div>
      </main>

      <Modal size='lg' show={viewModal} onClose={() => { setSelectedItem(null); setViewModal(false); }} popup>
        <Modal.Header />
        <Modal.Body>
          {selectedItem && (
            <div className="flex flex-col md:flex-row gap-5">
              <div className="w-full md:w-1/2 md:h-[500px] flex justify-center items-center border border-fontDark rounded-xl">
                <img
                  src={`https://backend.amarasinghemedicare.com/Upload/Pharmacy/${selectedItem.image}`}
                  alt={selectedItem.itemName}
                  className="object-cover h-full rounded-lg"
                />
              </div>

              <div className="w-full md:w-1/2 flex flex-col gap-3 justify-center">
                <div className='flex items-center justify-center gap-3 bg-yellow-400 p-4 rounded-2xl shadow-lg mb-4 flex-col sm:flex-row md:flex-row'>
                  <div className='w-44 md:w-96 rounded-full p-4 overflow-hidden bg-white'>
                    <img className='w-full' src={Image} alt="" />
                  </div>


                  <div className='flex flex-col gap-3'>
                    <h1 className='text-base'>අමරසිංහ වෛද්‍ය මධ්‍යස්ථානයට පැමිණීමෙන් ඔබට අවශ්‍ය සියලුම ඖෂධ සහ වෛද්‍ය උපකරණ අවම මිලට පහසුවෙන් ලබා ගත හැකිය. වැඩි විස්තර සඳහා පහත WhatsApp අංකය අමතන්න.</h1>
                    <h1 className='text-sm'>You can easily get all the medicines and medical equipment you need at the lowest price by visiting Amarasinghe Medical Centre. For more information, contact the WhatsApp number below.</h1>
                  </div>
                </div>

                <div>
                  <h3 className='text-sm font-extralight'>{selectedItem.category}</h3>
                  <h1 className="text-xl font-semibold text-blue">{selectedItem.itemName}</h1>
                  <p className="text-sm text-gray-950 mt-2">{selectedItem.description}</p>

                  <h1 className="text-base font-semibold text-fontDark mt-2 flex gap-2 items-center">
                    {
                      selectedItem.discount === 0 ? (
                        <span>රු{Number(selectedItem.price).toFixed(2)}</span>
                      ) : (
                        <div className="">
                          <span className="line-through mr-2 text-gray-400">රු{Number(selectedItem.price).toFixed(2)}</span>
                          <span className="font-bold text-red">රු{Number(selectedItem.price - (selectedItem.price * (selectedItem.discount / 100))).toFixed(2)}</span>
                        </div>
                      )
                    }
                  </h1>

                  <h3
                    className="text-sm font-semibold text-white mt-3 cursor-pointer text-blue-500 transition-transform duration-300 hover:scale-105 flex gap-1 items-center w-fit p-2 bg-[#25D366] rounded-3xl"
                    onClick={() => {
                      toast.success('Copied to clipboard');
                    }}
                  >
                    <IoLogoWhatsapp className='text-white text-3xl' /> Ask for More Info
                  </h3>
                </div>


              </div>
            </div>
          )}
        </Modal.Body>
      </Modal>
    </div>
  );
};

export default Pharmacy;
